/**
 * Admin — Library Routes
 *
 * Routes:
 * - /admin/steps                     → 'admin-steps-library'
 * - /admin/steps/new                 → 'admin-step-form' (création)
 * - /admin/steps/:stepId/edit        → 'admin-step-form' (édition + règles et checkboxes)
 * - /admin/rules                     → 'admin-rules-library'
 * - /admin/checkboxes                → 'admin-checkboxes-library'
 * - /admin/checkboxes/new            → 'admin-checkbox-form' (création)
 * - /admin/checkboxes/:checkboxId/edit → 'admin-checkbox-form' (édition)
 */

import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminLibraryRoutes: RouteObject[] = [
  {
    path: 'admin/steps',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_STEPS_LIBRARY, title: 'Bibliothèque — Étapes' },
  },
  {
    path: 'admin/steps/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_STEP_FORM, title: 'Nouvelle étape' },
  },
  {
    path: 'admin/steps/:stepId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_STEP_FORM, title: "Modifier l'étape" },
  },
  {
    path: 'admin/rules',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_RULES_LIBRARY, title: 'Bibliothèque — Règles' },
  },
  {
    path: 'admin/checkboxes',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_CHECKBOXES_LIBRARY, title: 'Bibliothèque — Checkboxes' },
  },
  {
    path: 'admin/checkboxes/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_CHECKBOX_FORM, title: 'Nouvelle checkbox' },
  },
  {
    path: 'admin/checkboxes/:checkboxId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_CHECKBOX_FORM, title: 'Modifier la checkbox' },
  },
];
